import React, { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl/maplibre';
import { hoverGeoJSON, sectionLineGeoJSON } from '../../lib/view-sync';

/** Map layers for the view sync: the current section line and the hover from section / 3D. */
export default function ViewSyncLayers({ sectionLine, hovered }) {
  const line = useMemo(() => sectionLineGeoJSON(sectionLine), [sectionLine]);
  const hover = useMemo(() => hoverGeoJSON(hovered, 'map'), [hovered]);
  return (
    <>
      {line.features.length > 0 && (
        <Source id="view-sync-section" type="geojson" data={line}>
          <Layer id="view-sync-section-casing" type="line" paint={{ 'line-color': '#0d1117', 'line-width': 6, 'line-opacity': 0.5 }} />
          <Layer id="view-sync-section-line" type="line" paint={{ 'line-color': '#f472b6', 'line-width': 3, 'line-dasharray': [2, 1.5] }} />
        </Source>
      )}
      {hover.features.length > 0 && (
        <Source id="view-sync-hover" type="geojson" data={hover}>
          <Layer id="view-sync-hover-halo" type="circle" paint={{ 'circle-radius': 12, 'circle-color': '#f472b6', 'circle-opacity': 0.25 }} />
          <Layer id="view-sync-hover-dot" type="circle" paint={{ 'circle-radius': 5, 'circle-color': '#f472b6', 'circle-stroke-color': '#fff', 'circle-stroke-width': 1.5 }} />
        </Source>
      )}
    </>
  );
}
